export default "__VITE_PUBLIC_ASSET__948e8cb0__"